import { Controller } from "@hotwired/stimulus"

// Modal udostępniania elementu Drive (folder/plik/dokument):
// wybór odbiorcy przez wspólny select intum-select (userzy/grupy/teamy/działy),
// lista dostępu z odbieraniem, dostęp ogólny (całe konto / ograniczony)
// i publiczny link "każdy z linkiem".
// Teksty widoczne dla usera przychodzą z serwera (partiale + data-values) - bez hardkodów.
export default class extends Controller {
  static targets = ["itemLabel", "content"]
  static values = {
    shareUrl: String,
    sharesUrl: String,
    unshareUrl: String,
    setRoleUrl: String,
    setAccessUrl: String,
    toggleLinkUrl: String,
    sharedText: String,
  }

  connect() {
    this._itemType = null
    this._itemId = null
    // przyciski otwierające modal ([data-drive-share-open]) leżą poza elementem kontrolera
    // (dropdowny na show/index), więc nasłuchujemy delegowanego kliknięcia na document
    this._openHandler = (event) => {
      const btn = event.target.closest("[data-drive-share-open]")
      if (!btn) return
      event.preventDefault()
      this.open(btn.dataset.itemType, btn.dataset.itemId, btn.dataset.itemName)
    }
    document.addEventListener("click", this._openHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._openHandler)
  }

  open(type, id, name) {
    this._itemType = type
    this._itemId = id
    this.itemLabelTarget.textContent = name || ""
    this.element.classList.remove("hidden")
    this.contentTarget.innerHTML = ""
    this._loadContent()
  }

  close() {
    this.element.classList.add("hidden")
    this._itemType = null
    this._itemId = null
  }

  // --- Nadawanie dostępu ---

  // intum-select po wyborze odbiorcy submituje form - przechwytujemy i wysyłamy share przez fetch
  submitShare(event) {
    event.preventDefault()
    const recipient = new FormData(event.currentTarget).get("recipient")
    if (recipient) this._share(recipient)
  }

  _share(recipient) {
    this._request("POST", this.shareUrlValue, { recipient }).then(r => {
      if (r.ok) {
        r.json().then(data => {
          if (data.name) window.IntumJs.notify(`${this.sharedTextValue}: ${data.name}`)
        })
        this._loadContent()
      }
    })
  }

  // --- Odbieranie dostępu ---

  removeShare(event) {
    const shareId = event.currentTarget.dataset.shareId
    this._request("DELETE", this.unshareUrlValue, { share_id: shareId }).then(r => {
      if (r.ok) {
        this._loadContent()
      } else {
        // np. próba odcięcia samego siebie - serwer zwraca komunikat błędu
        r.json().then(data => {
          if (data.error) window.IntumJs.notify(data.error, "error")
        }).catch(() => {})
      }
    })
  }

  // --- Poziom uprawnień (viewer/commenter/editor) ---

  changeRole(event) {
    const shareId = event.currentTarget.dataset.shareId
    const role = event.currentTarget.value
    this._request("PATCH", this.setRoleUrlValue, { share_id: shareId, role }).then(r => {
      if (!r.ok) this._loadContent()
    })
  }

  // --- Dostęp ogólny (całe konto / ograniczony) ---

  // przeładowuje treść, bo select odbiorcy i lista dostępu pokazują się tylko przy "ograniczony"
  changeAccess(event) {
    this._request("PATCH", this.setAccessUrlValue, { general_access: event.currentTarget.value }).then(r => {
      if (r.ok) this._loadContent()
    })
  }

  // --- Publiczny link ---

  toggleLink(event) {
    const el = event.currentTarget
    // zmiana selecta terminu = ponowne włączenie linku z nowym terminem (pusta wartość = bez terminu)
    const body = el.tagName === "SELECT" ? { enabled: true, expires_in_days: el.value } : { enabled: el.checked }
    this._request("PATCH", this.toggleLinkUrlValue, body).then(r => {
      if (r.ok) this._loadContent()
    })
  }

  copyLink(event) {
    event.preventDefault()
    const btn = event.currentTarget
    window.IntumJs.copyToClipboard(btn.dataset.copyUrl, btn, btn.dataset.copiedText)
  }

  // --- Helpery ---

  // przeładowuje serwerowo renderowaną zawartość modala (dostęp ogólny, select+lista dostępu, link)
  _loadContent() {
    const url = `${this.sharesUrlValue}?type=${encodeURIComponent(this._itemType)}&id=${encodeURIComponent(this._itemId)}`
    return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(r => r.text())
      .then(html => {
        this.contentTarget.innerHTML = html
      })
  }

  _request(method, url, params) {
    const csrfToken = document.querySelector("[name=\"csrf-token\"]").content
    return fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({
        type: this._itemType,
        id: this._itemId,
        ...params,
      }),
    })
  }
}
